<template>
  <div class="app-container">
    <Container
      :title="t('route.paymentSlipHistoryCashDetail')"
      :hasLine="true"
    >
      <template #main>
        <el-form
          :label-width="labelWidth"
          ref="cFormRef"
          label-position="left"
          style="margin-left:15%; font-size: 14px;"
        >
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('company.companyCode')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('pay.payee')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.payee }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.PaymentBankNO')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyBankAccount }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('pay.ReceivingBankNO')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.bankAccount }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.PaymentBankNumber')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyBankCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('pay.ReceivingBankNumber')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.bankCode }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.PaymentBankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyBankName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('pay.ReceivingBankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.bankName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.PaymentAmount')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatThousands(detailData.amount) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.currency')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.currency }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.paymentDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ paymentDateFormat(detailData.paymentDate) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.purpose')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.purpose }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                v-if="detailData.status === 2"
                :label="t('common.notes')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.comments }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </Container>
    <div
      class="dialog-footer"
    >
      <el-row :gutter="4">
        <el-col :span="8">
          <el-form-item
            label-width="180px"
            style="text-align: right;"
          >
            <el-button
              v-if="detailData?.status === 2 || (detailData?.status === 1 && detailData?.submitStatus === 1)"
              type="primary"
              @click="DownloadCertificateClick"
            >
              {{ t('pay.DownloadCertificate') }}
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
  </div>
  <div class="app-container">
    <Container
      :title="t('pay.payList')"
      :hasLine="true"
    >
      <template #main>
        <SimpleTable
          ref="tableRef"
          :listLoading="listLoading"
          :tableData="tableData"
          :columnStruct="columnStruct"
          :hadOperate="false"
        />
        <el-pagination
          :total="total"
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          style="text-align: right;"
        />
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import Container from '../../components/form/container/Container.vue'
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import {
  exportVoucherTemplate, getPaymentSlipHistoryCashDetail, getRelatedPaymentSlipPageList
} from '@/apis/paymentSlip/paymentSlipHistory'
import { PaymentSlipHistoryModel, RelatedPaymentSlipPageParamModel } from '@/model/paymentSlip/paymentSlipHistoryModel'
import { formatDate, formatThousands } from '@/utils'
import { ElMessage } from 'element-plus'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import { PaymentSlipModel } from '@/model/paymentSlip/paymentSlipModel'

export default defineComponent({
  name: 'PaymentSlipHistoryCashDetail',
  methods: { formatThousands },
  props: {
    inputData: {
      type: Object,
      required: true,
      default: null
    },
    labelWidth: {
      type: String,
      default: '680px'
    }
  },
  components: {
    SimpleTable,
    Container
  },
  setup() {
    const { t } = useI18n()
    const id = useRoute().params.id.toString()
    const paymentSlipTableStruct = [
      { prop: 'id', label: t('pay.id') },
      { prop: 'companyCode', label: t('company.companyCode') },
      { prop: 'payee', label: t('pay.payee') },
      { prop: 'reference', label: t('pay.reference') },
      { prop: 'amount', label: t('pay.amount'), formatter: (row: any) => formatThousands(row.amount), align: 'right' },
      { prop: 'currency', label: t('pay.currency') },
      { prop: 'dueDate', label: t('order.cutOffDate'), formatter: (row: any) => formatDate(row.dueDate, 'yyyy-MM-dd') },
      { prop: 'comments', label: t('pay.comments') },
      {
        prop: 'paymentDate',
        label: t('pay.paymentDate'),
        formatter: (row: any) => formatDate(row.paymentDate, 'yyyy-MM-dd')
      },
      { prop: 'purpose', label: t('pay.purposeView'), width: 170 }
    ]
    const dataMap = reactive({
      detailData: {} as PaymentSlipHistoryModel | null,
      paymentDate: '',
      tableData: Array<PaymentSlipModel>(),
      columnStruct: paymentSlipTableStruct,
      listLoading: true,
      limit: 10,
      total: 0,
      page: 1,
      async getData() {
        dataMap.listLoading = true
        const data = await getPaymentSlipHistoryCashDetail(id)
        if (data && data.data) {
          dataMap.detailData = data.data
        }
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      paymentDateFormat(paymentDate: Date): string {
        return formatDate(paymentDate, 'yyyy-MM-dd')
      },
      handleCurrentChange(page?: any) {
        dataMap.getPageList(page)
      },
      handleSizeChange(val: any) {
        dataMap.getPageList(null, val)
      },
      async getPageList(page?: any, limit?: any) {
        if (page) {
          dataMap.page = page
        }
        if (limit) {
          dataMap.limit = limit
        }
        dataMap.listLoading = true
        let historyId
        try {
          historyId = Number(id)
        } catch (error) {
          ElMessage({
            message: 'id 格式错误;' + id,
            type: 'error',
            duration: 2000
          })
          return
        }
        const params: RelatedPaymentSlipPageParamModel = {
          id: historyId,
          pageCurrent: dataMap.page,
          pageSize: dataMap.limit
        }
        const data = await getRelatedPaymentSlipPageList(params)
        if (data && data.data && data.data.list.length > 0) {
          dataMap.tableData = data.data.list
        } else {
          dataMap.tableData = []
        }
        dataMap.total = data?.data.totalCount ?? 0
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      }
    })
    const DownloadCertificateClick = async() => {
      if (dataMap.detailData && dataMap.detailData.paymentVoucher) {
        const formData = new FormData() as any
        formData.append('voucher', dataMap.detailData.paymentVoucher)
        const urlBlob = await exportVoucherTemplate(formData)
        if (urlBlob) {
          const link = document.createElement('a')
          link.href = urlBlob
          link.download = dataMap.detailData.paymentVoucher
          link.click()
          window.URL.revokeObjectURL(urlBlob)
        } else {
          ElMessage({
            message: '获取文件失败',
            type: 'error',
            duration: 2000
          })
        }
      } else {
        ElMessage({
          message: t('pay.paymentVoucherIsNull'),
          type: 'error',
          duration: 2000
        })
      }
    }
    onMounted(() => {
      dataMap.getData()
      dataMap.getPageList(null, 10)
    })
    return {
      t,
      DownloadCertificateClick,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>

</style>
